"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DocumentWithStar = function DocumentWithStar(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "24",
    height: "24",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16 5.5H8C7.93433 5.49995 7.86929 5.51285 7.8086 5.53796C7.74792 5.56307 7.69278 5.5999 7.64634 5.64634C7.5999 5.69278 7.56307 5.74792 7.53796 5.8086C7.51285 5.86929 7.49995 5.93433 7.5 6V18C7.5 18.1326 7.55268 18.2598 7.64645 18.3536C7.74021 18.4473 7.86739 18.5 8 18.5H16C16.1326 18.5 16.2598 18.4473 16.3536 18.3536C16.4473 18.2598 16.5 18.1326 16.5 18V6C16.5 5.86739 16.4473 5.74021 16.3536 5.64645C16.2598 5.55268 16.1326 5.5 16 5.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M14 12.5C13.8674 12.5 13.7402 12.4473 13.6464 12.3536C13.5527 12.2598 13.5 12.1326 13.5 12V4C13.5 3.86739 13.5527 3.74021 13.6464 3.64645C13.7402 3.55268 13.8674 3.5 14 3.5C14.1326 3.5 14.2598 3.55268 14.3536 3.64645C14.4473 3.74021 14.5 3.86739 14.5 4V12C14.5 12.1326 14.4473 12.2598 14.3536 12.3536C14.2598 12.4473 14.1326 12.5 14 12.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M18 8.5H10C9.86739 8.5 9.74021 8.44732 9.64645 8.35355C9.55268 8.25979 9.5 8.13261 9.5 8C9.5 7.86739 9.55268 7.74021 9.64645 7.64645C9.74021 7.55268 9.86739 7.5 10 7.5H18C18.1326 7.5 18.2598 7.55268 18.3536 7.64645C18.4473 7.74021 18.5 7.86739 18.5 8C18.5 8.13261 18.4473 8.25979 18.3536 8.35355C18.2598 8.44732 18.1326 8.5 18 8.5Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M17.182 11.182C17.0882 11.2758 16.961 11.3285 16.8284 11.3285C16.6958 11.3285 16.5687 11.2758 16.4749 11.182L10.818 5.52506C10.7702 5.47895 10.732 5.42378 10.7057 5.36275C10.6795 5.30173 10.6656 5.23608 10.665 5.16965C10.6644 5.10321 10.677 5.03732 10.7022 4.97582C10.7273 4.91433 10.7644 4.85846 10.8114 4.81148C10.8584 4.7645 10.9143 4.72736 10.9758 4.70222C11.0373 4.67708 11.1032 4.66445 11.1696 4.66506C11.236 4.66568 11.3017 4.67952 11.3627 4.7058C11.4237 4.73207 11.4789 4.77024 11.525 4.81808L17.182 10.4751C17.2757 10.5688 17.3284 10.696 17.3284 10.8285C17.3284 10.9611 17.2757 11.0883 17.182 11.182Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M17.182 5.52493L11.525 11.1819C11.4789 11.2297 11.4237 11.2679 11.3627 11.2942C11.3017 11.3205 11.236 11.3343 11.1696 11.3349C11.1032 11.3355 11.0373 11.3229 10.9758 11.2978C10.9143 11.2726 10.8584 11.2355 10.8114 11.1885C10.7644 11.1415 10.7273 11.0857 10.7022 11.0242C10.677 10.9627 10.6644 10.8968 10.665 10.8303C10.6656 10.7639 10.6795 10.6983 10.7057 10.6372C10.732 10.5762 10.7702 10.521 10.818 10.4749L16.475 4.81796C16.5211 4.77004 16.5763 4.7318 16.6373 4.70546C16.6983 4.67912 16.764 4.66522 16.8305 4.66457C16.897 4.66393 16.9629 4.67654 17.0245 4.70168C17.086 4.72682 17.1419 4.76399 17.1889 4.811C17.2359 4.85801 17.2731 4.91392 17.2983 4.97546C17.3234 5.03701 17.336 5.10295 17.3354 5.16943C17.3347 5.23591 17.3208 5.30159 17.2945 5.36263C17.2681 5.42367 17.2299 5.47885 17.182 5.52493Z",
    fill: props.foregroundColor
  }));
};

DocumentWithStar.defaultProps = {
  altText: "DocumentWithStar",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
DocumentWithStar.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = DocumentWithStar;
exports.default = _default;